import { PrimaryInput } from "common";

import * as S from "../styled";

export const EvidenceSidebarFloats = ({ floats, numbers, setNumbers }) => {
  return (
    <S.Block>
      {floats?.map((item) => (
        <S.Block key={item.name}>
          <S.Title>{item.name}</S.Title>
          <PrimaryInput
            name={item.name}
            type="number"
            value={numbers[item.description] || ""}
            onChange={(e) =>
              setNumbers((prevState) => ({
                ...prevState,
                [item.description]: e.target.value,
              }))
            }
            onWheel={(e) => e.target.blur()}
          />
        </S.Block>
      ))}
    </S.Block>
  );
};